'use client';

import { createContext } from 'react';
import { IAccordionVariants, accordionVariants } from './accordion.variants';

export type AccordionContextProps = {
  variant?: keyof typeof accordionVariants | (string & {});
  variants?: IAccordionVariants;
};

export const AccordionContext = createContext<AccordionContextProps>({});

export const AccordionProvider = AccordionContext.Provider;
